import React from 'react';
import {
  ReactZoomPanPinchContentRef,
  ReactZoomPanPinchProps,
  TransformComponent,
  TransformWrapper,
} from 'react-zoom-pan-pinch';

type TypePinchZoomViewerProps = {
  /** viewer에 표시할 요소 */
  children: React.ReactNode;
  /** viewer 하단에 표시할 요소 */
  bottomElement?: React.ReactNode;
  /** TransformWrapper 태그에 적용되는 속성 */
  wrapperConfig: ReactZoomPanPinchProps;
  /** TransformComponent 태그에 적용되는 속성 */
  contentsConfig: Record<string, unknown>;
  /** ReactZoomPanPinchContentRef를 참조하는 Ref */
  ref: React.Ref<ReactZoomPanPinchContentRef>;
};

const PinchZoomViewer = ({ children, bottomElement, wrapperConfig, contentsConfig, ref }: TypePinchZoomViewerProps) => {
  return (
    <TransformWrapper ref={ref} {...wrapperConfig}>
      <TransformComponent {...contentsConfig}>{children}</TransformComponent>
      {bottomElement}
    </TransformWrapper>
  );
};

PinchZoomViewer.displayName = 'PinchZoomViewer';

export default PinchZoomViewer;
